<template>
  <div class="flex w-full flex-col">
    <!-- Header Section -->
    <div class="flex items-center justify-start pb-8">
      <h1 class="text-5xl font-medium text-gray-900">{{ __('My Orders') }}</h1>
    </div>

    <!-- Stock Alert -->

    <!-- Table Container -->
    <div class="overflow-x-auto rounded-lg shadow-lg">
      <!-- Product Items -->
      <div
        class="scrollbar-thin mt-2 h-[600px] overflow-auto rounded-lg bg-white p-2 pr-4"
        style="scrollbar-gutter: stable"
      >
        <!-- Item 1 -->
        <template v-if="user_orders.length > 0">
          <div
            v-for="(user_order, index) in user_orders"
            :key="user_order.id"
            class="w-full"
            :class="isUserOrderUnfolded(user_order)"
          >
            <div
              class="grid grid-cols-1 items-center gap-y-1 border-b bg-white px-6 py-8 transition-all duration-200 hover:bg-gray-50 sm:grid-cols-11"
            >
              <div class="flex items-center justify-start">
                <span class="font-bold"> {{ index + 1 }}.</span>
              </div>

              <div
                class="col-span-3 flex flex-col items-start justify-center gap-y-2 py-2 sm:py-0"
              >
                <span class="font-bold"> {{ __('DATE') }}</span>
                <span>
                  {{ new Date(user_order.created_at).toLocaleString() }}
                </span>
              </div>

              <div
                class="col-span-2 flex flex-col items-start justify-center gap-y-2 py-2 sm:py-0"
              >
                <span>
                  {{ __('Total Points') }}
                </span>

                <span class="flex items-center justify-start gap-x-2">
                  <strong>{{ user_order.points }}</strong>
                  <Icon name="jobful_points_variant"></Icon>
                </span>
              </div>

              <div class="col-span-3">
                <div
                  class="flex flex-col items-start justify-center gap-y-2 py-2 sm:py-0"
                >
                  <span class="font-medium"> {{ __('ORDER STATUS') }}</span>
                  <FadeTransition>
                    <span>
                      {{ __('Your order status is :') }}
                      <span class="font-bold capitalize">{{
                        user_order.status
                      }}</span>
                    </span>
                  </FadeTransition>
                </div>
              </div>

              <div
                class="flex h-full items-center justify-end gap-x-4 sm:col-span-2"
              >
                <Icon
                  class="hover-lift-no-shadow cursor-pointer"
                  type="filled"
                  size="text-xl"
                  :name="
                    !isUserOrderUnfolded(user_order)
                      ? 'unfold_more'
                      : 'unfold_less'
                  "
                  @click.prevent="handleUnfoldUserOrder(user_order.id)"
                >
                </Icon>
              </div>
            </div>
            <template v-if="isUserOrderUnfolded(user_order)">
              <div
                v-for="(
                  typeOfOrderProdutVariant, type, index
                ) in user_order.order_product_variants"
                :key="index"
                class="col-span-3 grid min-h-32 grid-cols-3 border-b px-6 py-2 transition-all duration-200 hover:bg-gray-50 sm:col-span-11 sm:grid-cols-11"
                :class="
                  index ==
                  Object.keys(user_order.order_product_variants).length - 1
                    ? 'border-b-primary'
                    : 'border-b-gray-200'
                "
              >
                <div class="col-span-3 mb-2 flex flex-col sm:col-span-11">
                  <!-- <span class="font-medium"> {{ __('Details') }}: </span> -->
                  <div
                    class="mt-1 grid grid-cols-2 gap-2 text-sm text-zinc-600 sm:grid-cols-3"
                  >
                    <span class="font-semibold">
                      {{ __('Delivery type') }} :
                      <span class="font-medium capitalize text-zinc-600">
                        {{ type }}
                      </span>
                    </span>
                    <template
                      v-if="
                        type === 'offline' &&
                        typeOfOrderProdutVariant[0].order_shipping_detail
                      "
                    >
                      <span>
                        <strong> {{ __('Address: ') }}</strong>
                        {{
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .address
                        }}
                      </span>
                      <span
                        v-if="
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .detailed_address
                        "
                      >
                        <strong> {{ __('Detailed Address: ') }}</strong>
                        {{
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .detailed_address
                        }}
                      </span>

                      <span
                        v-if="
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .location
                        "
                      >
                        <strong> {{ __('Location: ') }}</strong>
                        {{
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .location
                        }}
                      </span>

                      <span
                        v-if="
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .email
                        "
                      >
                        <strong> {{ __('Email: ') }}</strong>
                        {{
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .email
                        }}
                      </span>
                      <span
                        v-if="
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .phone
                        "
                      >
                        <strong> {{ __('Phone: ') }}</strong>
                        {{
                          typeOfOrderProdutVariant[0].order_shipping_detail
                            .phone
                        }}
                      </span>
                    </template>

                    <template
                      v-if="
                        type === 'pickup' &&
                        typeOfOrderProdutVariant[0].product_variant?.product
                          ?.pickup_address
                      "
                    >
                      <span>
                        <strong> {{ __('Pick up address: ') }}</strong>
                        {{
                          typeOfOrderProdutVariant[0].product_variant.product
                            .pickup_address
                        }}
                      </span>
                    </template>
                  </div>
                </div>

                <div
                  v-for="(
                    order_product_variant, index
                  ) in typeOfOrderProdutVariant"
                  class="col-span-11 grid grid-cols-3 py-4 sm:grid-cols-11"
                  :class="
                    index === typeOfOrderProdutVariant.length
                      ? 'border-b border-b-gray-200'
                      : ''
                  "
                  :key="order_product_variant.id"
                >
                  <div
                    class="col-span-3 flex h-24 items-start justify-start gap-3 sm:col-span-4"
                  >
                    <div
                      @click.prevent="
                        redirectToPage(
                          'redesign.candidate.shop.products.show',
                          order_product_variant.product_variant.product.id
                        )
                      "
                      class="aspect-square cursor-pointer overflow-hidden rounded-lg shadow-md transition-all duration-200 hover:shadow-lg"
                    >
                      <img
                        :src="`/uploads/${order_product_variant.product_variant.product.primary_image.path}`"
                        :key="
                          order_product_variant.product_variant.product
                            .primary_image.id
                        "
                        :alt="__('Media image')"
                        onerror="this.src='https://placehold.co/44x44/cccccc/ffffff?text=Image'"
                        class="h-24 w-24 rounded-md border border-gray-200 object-cover shadow-md"
                      />
                    </div>
                    <div class="flex h-full w-full flex-col gap-y-2">
                      <div
                        class="w-1/2 truncate text-sm font-medium text-zinc-600"
                      >
                        {{
                          order_product_variant.product_variant.product.prodname
                        }}
                      </div>
                      <div
                        class="flex flex-row items-center justify-start gap-x-2"
                      >
                        <template
                          v-for="(attribute, index) in order_product_variant
                            .product_variant.formatted_attributes"
                        >
                          <div
                            v-if="attribute.name === 'Color'"
                            class="flex items-center justify-center gap-x-2 pr-2 text-sm font-medium text-zinc-600"
                            :class="
                              index ===
                              order_product_variant.product_variant
                                .formatted_attributes.length -
                                1
                                ? 'border-r-0'
                                : 'border-r border-zinc-200'
                            "
                          >
                            <span class="text-sm">{{ attribute.name }}: </span>
                            <div
                              class="h-4 w-4 rounded-full pl-2"
                              :style="{
                                backgroundColor: attribute.value.value
                              }"
                            ></div>
                          </div>

                          <div
                            v-else="!attribute.name === 'Color'"
                            class="pr-2 text-sm font-medium text-zinc-600"
                            :class="
                              index ===
                              order_product_variant.product_variant
                                .formatted_attributes.length -
                                1
                                ? 'border-r-0'
                                : 'border-r border-zinc-200'
                            "
                          >
                            {{ attribute.name }}: {{ attribute.value?.value }}
                          </div>
                        </template>
                      </div>
                      <div
                        class="w-1/2 truncate text-sm font-medium text-zinc-600"
                      >
                        {{ __('Quantity') }}:
                        {{ order_product_variant.quantity }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-span-1 flex items-center justify-start sm:col-span-2"
                  >
                    <div class="flex items-center justify-start gap-x-2">
                      <span class="font-bold">{{
                        order_product_variant.points
                      }}</span>
                      <Icon name="jobful_points_variant"></Icon>
                    </div>
                  </div>

                  <div
                    class="col-span-1 flex items-center justify-start pt-2 sm:col-span-3"
                  >
                    <span
                      :key="order_product_variant.status"
                      class="rounded-lg px-2 py-0.5 text-base capitalize transition-all duration-300"
                      :class="
                        order_product_variant.status === 'pending'
                          ? 'bg-status-inactive/10 text-status-inactive'
                          : order_product_variant.status === 'delivered'
                            ? 'bg-status-active/10 text-status-active'
                            : order_product_variant.status === 'cancelled'
                              ? 'bg-error/10 text-error'
                              : 'bg-[#371066]/10 text-[#371066]'
                      "
                    >
                      {{ order_product_variant.status }}
                    </span>
                  </div>

                  <div
                    class="col-span-1 flex w-full items-center justify-end sm:col-span-2"
                  >
                    <button
                      v-if="
                        order_product_variant.status === 'delivered' &&
                        !order_product_variant.product_variant.already_reviewed
                      "
                      @click="
                        ((selectedOrderProductVariant = order_product_variant),
                        (isReviewModalOpen = true))
                      "
                      class="btn btn-outline hover-lift-no-shadow flex items-center justify-start gap-x-2"
                    >
                      <Icon
                        name="reviews"
                        type="filled"
                        class="text-primary"
                      ></Icon>
                      <span class="text-primary">
                        {{ __('Review this product') }}</span
                      >
                    </button>
                    <button
                      v-else
                      @click="
                        redirectToPage(
                          'redesign.candidate.shop.products.show',
                          order_product_variant.product_variant.product.id
                        )
                      "
                      class="btn btn-ghost hover-lift-no-shadow flex items-center justify-end gap-x-2"
                    >
                      <span class="text-primary">
                        {{ __('View Item') }}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div
            class="flex h-full w-full items-center justify-center text-zinc-400"
          >
            {{ __('No orders found') }}
          </div>
        </template>

        <div
          v-if="
            user_orders.length > 0 &&
            data.user_orders.meta.current_page !==
              data.user_orders.meta.last_page
          "
          class="mt-auto flex w-full items-end justify-center py-2"
        >
          <button
            :disabled="isLoadingShowMore"
            class="hover-lift-no-shadow font-medium text-primary"
            :class="{ 'opacity-50': isLoadingShowMore }"
          >
            <div
              class="flex items-center justify-center gap-2"
              @click="
                handlePageChange({
                  page: data.user_orders.meta.current_page + 1,
                  reset: false
                })
              "
            >
              <span>{{ __('Show More') }}</span>
              <Icon
                v-if="isLoadingShowMore"
                class="animate-spin text-lg"
                name="progress_activity"
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>

  <CandidateShopProductsReviewModal
    :data="selectedOrderProductVariant.product_variant"
    @cancel="isReviewModalOpen = false"
    @save="handleReviewProduct"
    v-if="isReviewModalOpen"
  ></CandidateShopProductsReviewModal>
</template>
<script setup>
  import { nextTick, onMounted, ref } from 'vue';

  import Icon from '@/components/global/Icon.vue';
  import FadeTransition from '@/components/global/FadeTransition.vue';
  import { __ } from '@/helpers';

  import { useToast } from 'vue-toastification';
  import CandidateShopProductsReviewModal from './components/CandidateShopProductsReviewModal.vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true
    }
  });

  const isReviewModalOpen = ref(false);
  const selectedOrderProductVariant = ref(null);
  const user_orders = ref(props.data.user_orders.data);
  const data = ref(props.data);
  const toast = useToast();
  const isLoadingUserOrders = ref(false);
  const isLoadingShowMore = ref(false);

  const redirectToPage = (name, params) => {
    window.location.href = route(name, params);
  };
  const unfoldedUserOrders = ref([]);

  const handleUnfoldUserOrder = (userOrderId) => {
    const user_order = user_orders.value.find(
      (item) => item.id === userOrderId
    );

    if (unfoldedUserOrders.value.find((item) => item.id === userOrderId)) {
      unfoldedUserOrders.value = unfoldedUserOrders.value.filter(
        (unfoldedUserOrder) => unfoldedUserOrder.id !== userOrderId
      );
    } else {
      unfoldedUserOrders.value.push({
        id: userOrderId,
        updated_at: user_order.updated_at
      });
    }
  };

  const isUserOrderUnfolded = (user_order) => {
    return unfoldedUserOrders.value.find(
      (unfoldedUserOrder) => unfoldedUserOrder.id === user_order.id
    );
  };

  const handlePageChange = async ({ page, reset = false }) => {
    if (isLoadingUserOrders.value) return;

    if (reset) {
      data.value.user_orders.meta.current_page = 1;
      user_orders.value = [];
    }
    isLoadingShowMore.value = true;
    isLoadingUserOrders.value = true;
    try {
      const response = await axios.get(
        route('redesign.candidate.shop.orders.load-more', {
          page: page
        })
      );

      data.value.user_orders.meta = response.data.data.user_orders.meta;
      if (reset) {
        user_orders.value = response.data.data.user_orders.data;
      } else {
        user_orders.value.push(...response.data.data.user_orders.data);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || __('Something went wrong'));
    } finally {
      isLoadingUserOrders.value = false;
      isLoadingShowMore.value = false;
    }
  };

  const handleReviewProduct = async (eventData) => {
    try {
      const response = await axios.post(
        route(
          'redesign.candidate.shop.products.review',
          selectedOrderProductVariant.value.product_variant.product.id
        ),
        {
          rating: eventData.rating
        }
      );

      if (response.data.message) {
        toast.success(response.data.message);
        selectedOrderProductVariant.value.product_variant.already_reviewed = true;
        isReviewModalOpen.value = false;
      } else {
        toast.error(__('Failed to submit review.'));
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(__('An error occurred while submitting your review.'));
      }
    }
  };
</script>
